import { GetAdCampaignResponse } from 'api';
import { checkHasContentDetail } from './utils';

export const hasAdCampaignsSelector = (d: GetAdCampaignResponse) =>
  Boolean(d?.requests.some(checkHasContentDetail));

export const previousAdCampaignsSelector = (d: GetAdCampaignResponse) =>
  d?.requests.filter(checkHasContentDetail);
